import { collection, onSnapshot, query } from "firebase/firestore";
import { firestore } from "../../../configs/FirebaseConfig";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_NOTIFICATIONS_TABLE, FIRESTORE_REGIONS_TABLE } from "../../../constants/FirestoreConstant";
import { COMPANY_COUNTRY_CODE } from "../../../constants/CompanyConstants";

export function useNotifications() {
  const { data, error } = useSWRSubscription("notifications", (key, { next }) => {
    const q = query(
      collection(firestore, `${FIRESTORE_REGIONS_TABLE}/${COMPANY_COUNTRY_CODE}/${FIRESTORE_NOTIFICATIONS_TABLE}`),
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        try {
          const notifications = snapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          next(null, notifications);
        } catch (err) {
          next(err, null);
        }
      },
      (error) => {
        next(error, null);
      },
    );

    return unsubscribe;
  });

  return {
    data,
    error,
    loading: !data && !error,
  };
}
